import React, { useState } from 'react';
import { BackgroundImage, StyledTopicTeaser, TopicDiv, TopicLink } from './TopicTeaser.styles';
import { Colors } from '../../../../../play-core/styles/Colors';
import { topicColors } from '../../../../../play-core/styles/topic-colors';
import { usePath } from '../../../config/VideoAppContext';
import { useDataDispatch } from '../../../providers/DataProvider/DataContext';
import { useDeviceState } from '../../../providers/DeviceProvider/DeviceContext';
import { teaserImageWidth } from '../../Image/image-width';
import { PlayImage } from '../../Image/PlayImage';
import { TopicImageOverlay } from '../TeaserActions/TopicImageOverlay';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TopicTeaser = ({
  topic,
  width = teaserImageWidth,
  onClick,
  onlyFavor = false,
  ...rest
}) => {
  const {
    topicPath
  } = usePath();
  const dataDispatch = useDataDispatch();
  const {
    isTouchDevice
  } = useDeviceState();
  const [isHovering, setHover] = useState(false);
  const [isFocused, setFocus] = useState(false);
  const showTeaserImage = (!onlyFavor || isHovering || topic.isFavorite) && !!topic.imageUrl;
  const firstColor = showTeaserImage ? Colors.BLACK : topicColors[topic.urn]?.firstColor || Colors.BLACK;
  const secondColor = showTeaserImage ? Colors.SRF_484848 : topicColors[topic.urn]?.secondColor || Colors.SRF_484848;
  const onFavorite = () => {
    dataDispatch({
      type: 'toggle-topic-favorite',
      topicId: topic.id
    });
  };
  return /*#__PURE__*/_jsxs(StyledTopicTeaser, {
    onMouseEnter: () => {
      // onMouseEnter blocks onClick event on IOS devices -> only set hover if it's not a touch device
      !isTouchDevice && setHover(true);
    },
    onMouseLeave: () => setHover(false),
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    onClick: event => {
      const target = event.target;
      if (target.tagName?.toLowerCase() === 'a' && onClick) {
        onClick();
      }
    },
    firstColor: firstColor,
    secondColor: secondColor,
    children: [topic.imageUrl && /*#__PURE__*/_jsx(BackgroundImage, {
      showTeaserImage: showTeaserImage,
      children: /*#__PURE__*/_jsx(PlayImage, {
        aspectRatio: '16/9',
        src: topic.imageUrl,
        width: width,
        alt: topic.title
      })
    }), onlyFavor ? /*#__PURE__*/_jsx(TopicDiv, {
      tabIndex: 0,
      onClick: onFavorite,
      "aria-label": topic.title,
      children: topic.title
    }) : /*#__PURE__*/_jsx(TopicLink, {
      to: topicPath(topic.title),
      children: topic.title
    }), /*#__PURE__*/_jsx(TopicImageOverlay, {
      topicId: topic.id,
      isFocused: isFocused,
      isHovering: isHovering,
      hasHoverShadow: false,
      ...rest
    })]
  });
};